import { render } from "./RadioPanel.vue?vue&type=template&id=a504bce6&scoped=true&lang=html"
import script from "./RadioPanel.vue?vue&type=script&lang=js"
export * from "./RadioPanel.vue?vue&type=script&lang=js"

import "./RadioPanel.vue?vue&type=style&index=0&id=a504bce6&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a504bce6"]])

export default __exports__